import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import WarehouseService from "../../../services/WarehouseService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import AbonnementService from "../../../services/MarketingService/AbonnementService";
import { Alert, Snackbar } from "@mui/material";
import DataTableListCarteCadeau from "./DataTableListCarteCadeau";
import CardMagasinhome from "../../../components/homePage/cardMagasinhome";
import DataTableListAbonnementDetails from "./DataTableListAbonnementDetails";
// Dummy Data
// const dummyData = [
//   {
//     id: 1,
//     ref: "AB123",
//     name: "Subscription 1",
//     product: { barcode: "123456", name: "Product A" },
//     creationDate: "2024-01-01",
//     price: 100,
//   },
//   {
//     id: 2,
//     ref: "CD456",
//     name: "Subscription 2",
//     product: { barcode: "789012", name: "Product B" },
//     creationDate: "2024-02-15",
//     price: 150,
//   },
//   {
//     id: 3,
//     ref: "EF789",
//     name: "Subscription 3",
//     product: { barcode: "345678", name: "Product C" },
//     creationDate: "2024-03-10",
//     price: 200,
//   },
// ];

// const listCarteCadeaux = generateDummyData();

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AbonnementDetails = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();


  const [listAbonnement, setListAbonnement] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [abonnement, setAbonnement] = useState(null);

  useEffect(() => {
    AbonnementService.getAllAbonnementDetails(getCurrentUserId(), sessionStorage.getItem("idAbonnement"))
      .then((response) => {
        if (response.data.success) {
          // setWarehousesSource(response.data.success);
          setAbonnement(response.data.success.abonnement);
          setListAbonnement(response.data.success.clientsAbonnementsList);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);


  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
        <section className="content">
          <div className="row">
        <div className="col-sm-4 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-barcode"></i> {/* Reference icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Abonnement</span>
              <span className="info-box-number">{abonnement?.ref}-{abonnement?.name}</span>
            </div>
          </div>
        </div>
       
        <div className="col-sm-4 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-gift"></i> {/* Gift card icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Prix abonnement</span>
              <span className="info-box-number">{abonnement?.price}</span>
            </div>
          </div>
        </div>
       
        <div className="col-sm-4 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className={`fas ${abonnement?.isActive === 1 ? "fa-check-circle" : "fa-times-circle"}`}></i> {/* Status icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Status</span>
              <span className="info-box-number">
                {abonnement?.isActive === 1 ? "Active" : "Desactive"}
              </span>
            </div>
          </div>
        </div>
        </div>
        <div className="row">
        <div className="col-sm-4 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-box"></i> {/* Product icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Produit</span>
              <span className="info-box-number">{abonnement?.product?.barcode}-{abonnement?.product?.name}</span>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-barcode"></i> {/* Reference icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Prix initial par produit</span>
              <span className="info-box-number">{abonnement?.initialPricePerOne}</span>
            </div>
          </div>
        </div>
        <div className="col-sm-4 col-12 p-2">
          <div className="info-box bg-dark text-white p-3 rounded">
            <span className="info-box-icon">
              <i className="fas fa-gift"></i> {/* Gift card icon */}
            </span>
            <div className="info-box-content">
              <span className="info-box-number">Nombre par abonnement</span>
              <span className="info-box-number">{abonnement?.nbrAbonnement}</span>
            </div>
          </div>
        </div>
        </div>
      </section>

    
      <section class="content mt-2">
        <div class="card">
          <div class="card-header  ">
            <h3 class="card-title">Les abonnements</h3>
            <div class="card-tools">
              <button
                type="button"
                class="btn btn-tool"
                data-card-widget="collapse"
                title="Collapse"
              >
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>
          <div class="card-body ">
            {listAbonnement && Array.isArray(listAbonnement)&& <DataTableListAbonnementDetails listAbonnement={listAbonnement} />}
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AbonnementDetails);
